import { CountUp } from "countup.js";
export default class Teamwork {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.page = document.querySelector(".page__wrap");
        this.numbers = document.querySelectorAll(`${element}__numbers`);
        this.throttled = false;
        this.bindEvents();
    }
    bindEvents() {
        window.addEventListener("scroll", e => this.scrollThrottler(e));
    }
    scrollThrottler() {
        if (!this.throttled) {
            this.numbers.forEach(number => {
                this.boxesVisible(number);
            });

            this.throttled = true;
            setTimeout(() => (this.throttled = false), 400);
        }
    }
    boxesVisible(element) {
        const rect = element.getBoundingClientRect();

        if (rect.top - window.innerHeight < 0) {
            if (!element.classList.contains("teamwork__numbers--isVisible")) {
                element.classList.add("teamwork__numbers--isVisible");
                this.startAnimating(element);
            }
        }
    }
    startAnimating(element) {
        const options = {
            separator: ".",
            decimal: ","
        };
        if (element.classList.contains("teamwork__numbers--isVisible")) {
            let number = element.innerHTML.replace(".", "");

            let countUp = new CountUp(element, parseInt(number), options);
            countUp.start();
        }
    }
}
